import React, { useEffect, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (email) {
      localStorage.setItem("email", email);
      navigate("/patentform");
    }
  }, [email, navigate]);

  const isAllowedDomain = (email) => {
    return email.endsWith("@whitecode.co.in") || email.endsWith("@brainiac.co.in");
  };

  return (
    <div>
      <h2>Login with Google</h2>
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          const decoded = jwtDecode(credentialResponse.credential);
          const userEmail = decoded.email;

          if (isAllowedDomain(userEmail)) {
            setEmail(userEmail);
          } else {
            alert("Access denied. Only @whitecode.co.in or @brainiac.co.in emails are allowed.");
          }
        }}
        onError={() => {
          console.log("Login Failed");
        }}
      />
    </div>
  );
};

export default Login;
